<template>
  <div>
    <vs-popup :title="$t('CurrencyType')" :active.sync="showModal">
      <div class="vx-row mb-6">
        <div class="vx-col w-full my-2">
          <label class="vs-select--label my-1">{{
            $t("SourceCurrency")
          }}</label>

          <vs-input
            class="m-0"
            name="currencyType"
            v-model="model.sourceCurrencyName"
            dir="rtl"
          >
          </vs-input>
          <span
            class="text-danger text-sm"
            v-show="errors.has('currencyType')"
            >{{ errors.first("currencyType") }}</span
          >
        </div>
        <div class="vx-col w-full my-2">
          <label class="vs-select--label my-1">{{
            $t("TargetCurrency")
          }}</label>

          <vs-input
            class="m-0"
            name="TargetCurrencyType"
            v-model="model.targetCurrencyName"
            dir="rtl"
          >
          </vs-input>
          <span
            class="text-danger text-sm"
            v-show="errors.has('TargetCurrencyType')"
            >{{ errors.first("TargetCurrencyType") }}</span
          >
        </div>
        <div class="vx-col w-full my-2">
          <vs-input v-model="model.rate" name="rate" :label="$t('Rate')"  type="number"/>
          <span class="text-danger text-sm" v-show="errors.has('rate')">{{
            errors.first("rate")
          }}</span>
        </div>

        <div class="flex justify-end w-full ml-5">
          <vs-button
            type="filled"
            class="mb-4 mt-4"
            @click.prevent="submitForm"
            :disabled="
              !model.sourceCurrencyName ||
              !model.rate ||
              !model.targetCurrencyName
            "
            >{{ $t("Save") }}</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<style lang="scss">
body[dir="rtl"] .vs-popup--content {
  overflow-y: scroll !important;
}
</style>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";

const dict = {
  custom: {
    TargetCurrencyType: {
      required: "لطفا ارز مقصد را وارد نمایید.",
    },
    currencyType: {
      required: "لطفا ارز مبدا را وارد نمایید.",
    },
    bPrice: {
      required: "لطفا نرخ را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);

export default {
  components: {
    "v-select": vSelect,
  },
  props: {
    show: { default: false },
    model: {
      default: {},
    },
  },
  data() {
    return {
      departman: "",
      popupTitle: "",
      disabled: false,
      model: {},
      price: null,
      currencyTypes: [
        { name: "ریال", id: 1 },
        { name: "دلار", id: 2 },
        { name: "درهم", id: 3 },
      ],
    };
  },
  computed: {
    showModal: {
      get: function () {
        this.model.purchaseInvoiceId = this.$route.params.id;

        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createAccount: "currency/createCurrency",
      updateAccount: "currency/editCurrency",
    }),
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.model.rate = +this.model.rate;
          if (this.model.id != null) {
            this.updateAccount(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            });
          } else {
            this.createAccount(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            });
          }
        } else {
          // form have errors
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.disabled = false;

        if (this.model.id) this.popupTitle = "CurrencyExchange";
        else this.popupTitle = "CurrencyExchange";
      }
      this.$validator.reset();
    },
  },
};
</script>
